import _ from 'lodash';

export const GAMETITLE_IDS =
{
  E_BEACHCOLLECTOR: 1,
  E_CATCHTHEMOLE: 2,
  E_MOVINGBALLS: 3,
  E_NUMBERSVSLETTERS: 4,
  E_COLOREDCONFUSION: 5,
  E_RUNFORCHEESE: 6,
  E_EASTEREGG: 7,
  E_SALESMARKET: 8,
  E_FOLLOWTHEORDER: 9,
  E_TRAFFICLIGHTS: 10,
  E_MAKINGNUMBERS: 11,
  E_ONETOFIFTY: 12,
  E_MEMORYMATRIX: 13,
  E_NUMBERCRUSHER: 14,
  E_FINDINGPATH: 15,
  E_STEPPINGSTONE: 16,
  E_SPEEDDOWN: 17,
  E_CATCHINGFROG: 18,
  E_CHOOSEWORD: 19,
  E_SPEEDPACK: 20
}

export const GAMETITLES = [
  'E_BEACHCOLLECTOR',
  'E_CATCHTHEMOLE',
  'E_MOVINGBALLS',
  'E_NUMBERSVSLETTERS',
  'E_COLOREDCONFUSION',
  'E_RUNFORCHEESE',
  'E_EASTEREGG',
  'E_SALESMARKET',
  'E_FOLLOWTHEORDER',
  'E_TRAFFICLIGHTS',
  'E_MAKINGNUMBERS',
  'E_ONETOFIFTY',
  'E_MEMORYMATRIX',
  'E_NUMBERCRUSHER',
  'E_FINDINGPATH',
  'E_STEPPINGSTONE',
  'E_SPEEDDOWN',
  'E_CATCHINGFROG',
  'E_CHOOSEWORD',
  'E_SPEEDPACK'
];

export const GAME_CATEGORY = {
  E_MEMORY: 1,
  E_CONCENTRATION: 2,
  E_REACTION: 3,
  E_LOGIC: 4,
  E_SPEED: 5,
};

export const GAME_CATEGORY_STRING = [
  "E_MEMORY",
  "E_CONCENTRATION",
  "E_REACTION",
  "E_LOGIC",
  "E_SPEED",
];

export const getGameCategory = (game_title) => {
  switch (game_title) {
    case "E_FOLLOWTHEORDER":
    case "E_BEACHCOLLECTOR":
    case "E_MEMORYMATRIX":
    case "E_SPEEDDOWN":
      return GAME_CATEGORY.E_MEMORY;

    case "E_MOVINGBALLS":
    case "E_CATCHTHEMOLE":
    case "E_STEPPINGSTONE":
    case "E_CATCHINGFROG":
      return GAME_CATEGORY.E_CONCENTRATION;

    case "E_COLOREDCONFUSION":
    case "E_NUMBERSVSLETTERS":
    case "E_NUMBERCRUSHER":
    case "E_CHOOSEWORD":
      return GAME_CATEGORY.E_REACTION;

    case "E_SALESMARKET":
    case "E_EASTEREGG":
    case "E_MAKINGNUMBERS":
    case "E_FINDINGPATH":
      return GAME_CATEGORY.E_LOGIC;

    case "E_TRAFFICLIGHTS":
    case "E_RUNFORCHEESE":
    case "E_ONETOFIFTY":
    case "E_SPEEDPACK":
      return GAME_CATEGORY.E_SPEED;
    default:
      return null
  }
}


export const getNQ = (stageInfo) => {
  if (Object.keys(stageInfo).length < 1) {
    return [0, 0, 0, 0, 0];
  }
  const stages = _(stageInfo)
    .map((v, k) => ({ id: k, category: getGameCategory(k), stage: v }))
    .groupBy('category')
    .value();

  console.log('stages', stages);
  const _nq = _.map(stages, (v, k) => {
    const minGame = _.minBy(v, 'stage');
    const maxGame = _.maxBy(v, 'stage');
    let score = maxGame.stage * 30;
    if (minGame.stage === maxGame.stage) {
      score += 300;
    }
    return score;
  });

  const nqo = _nq.reduce((acc, cur, curIdx) => ({ ...acc, [GAME_CATEGORY_STRING[curIdx]]: cur }), {});
  return [nqo.E_SPEED, nqo.E_REACTION, nqo.E_MEMORY, nqo.E_LOGIC, nqo.E_CONCENTRATION];
}

// Nq, point 계산식

// CREATE DEFINER=`lu`@`%` PROCEDURE `USP_Game_Result_Update`(user BIGINT, category int, game int, stage int, training int)
// BEGIN

// DECLARE result BIGINT;
// DECLARE _point INT;
// DECLARE _order INT;
// DECLARE brain0 INT;
// DECLARE brain1 INT;
// DECLARE brain2 INT;
// DECLARE brain3 INT;
// DECLARE brain4 INT;
// DECLARE game1 INT;
// DECLARE game2 INT;
// DECLARE nqpoint INT;
// DECLARE maxstage INT;
// DECLARE MSG VARCHAR(1000);

// SET maxstage = 30;

// SELECT f_index INTO result FROM account WHERE f_index = user;

// IF result != '' THEN

// 	IF stage = 0 THEN # tutorial
// 		INSERT INTO game SET f_user = user, f_category = category, f_game = game, f_stage = 1, f_datetime = now();

// 		SET MSG='game_tutorial_success';
// 		SELECT result, MSG;
// 	ELSE
// 	# stage
// 		IF stage < maxstage THEN
// 			UPDATE game SET f_stage = stage + 1, f_datetime = now() WHERE f_user = user AND f_category = category AND f_game = game;
// 		END IF;

// 	# point 계산
// 		IF training = 1 THEN
// 			SELECT f_point INTO _point FROM user WHERE f_user = user;
// 			SELECT f_game_order INTO _order FROM training_setting WHERE f_user = user AND DATEDIFF(now(), DATE_FORMAT(CONVERT(f_datetime, DATE), '%Y%m%d')) = 0;

// 			IF _order < 5 THEN
// 				SET _point = _point + 30;
// 				SET _order = _order + 1;

// 				IF _order = 5 THEN
// 					SET _point = _point + 50;
// 				END IF;

// 				UPDATE user SET f_point = _point WHERE f_user = user;
// 				UPDATE training_setting SET f_game_order = _order WHERE f_user = user AND DATEDIFF(now(), DATE_FORMAT(CONVERT(f_datetime, DATE), '%Y%m%d')) = 0;
// 			END IF;

// 		END IF;

// 	# nq 계산
//         SELECT max(f_stage) INTO game1 FROM game WHERE f_user = user AND f_category = category group by f_category;
//         SELECT min(f_stage) INTO game2 FROM game WHERE f_user = user AND f_category = category group by f_category;

// 		SET nqpoint = game1 * 30;

// 		IF game2 = maxstage THEN
// 			SET nqpoint = nqpoint + 300;
// 		END IF;


// 		IF category = 1 THEN
// 			UPDATE user SET f_brain0 = nqpoint WHERE f_user = user;
// 			UPDATE nq SET f_brain0 = nqpoint WHERE f_user = user AND DATEDIFF(now(), DATE_FORMAT(CONVERT(f_datetime, DATE), '%Y%m%d')) = 0;
// 		ELSEIF category = 2 THEN
// 			UPDATE user SET f_brain1 = nqpoint WHERE f_user = user;
// 			UPDATE nq SET f_brain1 = nqpoint WHERE f_user = user AND DATEDIFF(now(), DATE_FORMAT(CONVERT(f_datetime, DATE), '%Y%m%d')) = 0;
// 		ELSEIF category = 3 THEN
// 			UPDATE user SET f_brain2 = nqpoint WHERE f_user = user;
// 			UPDATE nq SET f_brain2 = nqpoint WHERE f_user = user AND DATEDIFF(now(), DATE_FORMAT(CONVERT(f_datetime, DATE), '%Y%m%d')) = 0;
// 		ELSEIF category = 4 THEN
// 			UPDATE user SET f_brain3 = nqpoint WHERE f_user = user;
// 			UPDATE nq SET f_brain3 = nqpoint WHERE f_user = user AND DATEDIFF(now(), DATE_FORMAT(CONVERT(f_datetime, DATE), '%Y%m%d')) = 0;
// 		ELSEIF category = 5 THEN
// 			UPDATE user SET f_brain4 = nqpoint WHERE f_user = user;
// 			UPDATE nq SET f_brain4 = nqpoint WHERE f_user = user AND DATEDIFF(now(), DATE_FORMAT(CONVERT(f_datetime, DATE), '%Y%m%d')) = 0;
// 		END IF;

// 		SELECT f_brain0, f_brain1, f_brain2, f_brain3, f_brain4 INTO brain0, brain1, brain2, brain3, brain4 FROM user WHERE f_user = user;

// 		UPDATE user SET f_brain = (brain0 + brain1 + brain2 + brain3 + brain4) / 5 WHERE f_user = user;

// 		SET MSG='game_result_success';
// 		SELECT result, MSG;
//     END IF;

// ELSE

// 	SET result=-1;
// 	SET MSG='game_result_fail';
// 	SELECT result, MSG;

// END IF;

// END